import { FileReference } from '@kaizenplatform/belfast-entity';
import { ClassAttributes, createElement, Fragment } from 'react';

import { DynamicSchemaDefinitionFiles } from '../../../../../generated/graphql';
import { EnhancedBatchDownload } from '../../../../connected/EnhancedBatchDownload';
import { FileListContainer } from '../../FileList';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionFiles, 'label'>;
  bucketId: string;
  files: FileReference[];
  className?: string;
}

const AsFiles = ({ field, bucketId, files, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      <>
        <FileListContainer files={files} />
        {files.length >= 2 ? <EnhancedBatchDownload bucketId={bucketId} /> : null}
      </>
    </Base>
  );
};

export default AsFiles;
